import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutProspectConversionRateReport extends Layout {
    checkboxIncludeMarketingPlan: Checkbox;
    checkboxPageBreak: Checkbox;
    excludabletextboxCustomers: ExcludableTextbox;
    excludabletextboxOperationsUser: ExcludableTextbox;
    excludabletextboxSalesManager: ExcludableTextbox;
    excludabletextboxSalesperson: ExcludableTextbox;
    sourceProspectConversionRateReport: DataSource;
    switchInclude: Switch;
    textboxConversionDate: Textbox;
    textboxGroupBy: Textbox;
    textboxSortBy: Textbox;
    textboxStartDate: Textbox;
}
